//material-ui
import { Grid, GridProps } from "@mui/material";

interface SpaceGridItemProps {
	maxCols?: number;
	smMargin?: boolean; //add margin on small screens
}

const SpacedGridItem: React.FC<SpaceGridItemProps & GridProps & React.ComponentProps<typeof Grid>> = ({ maxCols, smMargin, children, ...props }) => {
	maxCols = maxCols || 3;
	let md = 6;
	let lg = 4;

	const mbxs = smMargin ? 1 : 0;

	if (maxCols === 2) {
		md = 6;
		lg = 6;
	}
	if (maxCols === 1) {
		md = 12;
		lg = 12;
	}

	return (
		<Grid item xs={12} md={md} lg={lg} m={{ xs: mbxs, md: 0 }} {...props}>
			{children}
		</Grid>
	);
};

export default SpacedGridItem;
